export const getExpandedThumbRange = (thumbsCount) => ({
  start: 0,
  end: Math.max(0, thumbsCount - 1)
});

export const getCollapsedThumbRanges = (leftStart, maxThumbs, thumbsCount) => {
  const safeMax = Math.max(0, maxThumbs || 0);
  if (safeMax === 0) {
    return {
      left: { start: 0, end: 0 },
      right: { start: 0, end: 0 }
    };
  }

  const pageSize = safeMax * 2;
  let start = Math.max(0, leftStart || 0);

  if (thumbsCount > pageSize) {
    start = Math.min(start, thumbsCount - pageSize);
  } else {
    start = 0;
  }

  return {
    left: { start, end: start + safeMax - 1 },
    right: { start: start + safeMax, end: start + pageSize - 1 }
  };
};

export const thumbsFitWithoutScroll = (maxThumbs, thumbsCount) =>
  maxThumbs * 2 >= thumbsCount;
